import React, { useEffect, useState } from "react";
import { listSchoolsDirectory, joinSchool, getMyMembership } from "./happyschoolApi";
import { setActiveSchoolId } from "./activeSchool";

// Màn hình tham gia trường học (đăng nhập lần đầu / chưa thuộc trường nào).
const HappySchoolJoin = ({ accountName, onJoined }) => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [picked, setPicked] = useState(null); // {id, name}
  const [role, setRole] = useState(null); // "staff" | "student"
  const [name, setName] = useState(accountName || "");
  const [dob, setDob] = useState("");
  const [cccd, setCccd] = useState("");
  const [lop, setLop] = useState(""); // HS: nhập Lớp thay cho CCCD
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // "matched" | "pending" | "already"

  useEffect(() => { if (accountName) setName(accountName); }, [accountName]);

  useEffect(() => {
    listSchoolsDirectory()
      .then(async (list) => {
        setSchools(list || []);
        // Đã gửi yêu cầu tham gia nhưng chưa khớp hồ sơ (đang chờ nhà trường
        // duyệt) thì hiện thẳng màn "chờ xác thực" — không bắt chọn lại từ đầu
        // mỗi lần tải trang.
        const checks = await Promise.all(
          (list || []).map((s) => getMyMembership(s.id).then((m) => ({ s, m })).catch(() => null))
        );
        const pendingHit = checks.find((c) => c && c.m && c.m.request && c.m.request.status === "pending");
        if (pendingHit) {
          setPicked(pendingHit.s);
          setRole(pendingHit.m.request.role);
          setResult("pending");
        }
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const reset = () => { setPicked(null); setRole(null); setName(accountName || ""); setDob(""); setCccd(""); setLop(""); setResult(null); setError(""); };

  const submit = async () => {
    const isHS = role === "student";
    if (!name.trim() || !(isHS ? lop.trim() : cccd.trim()) || !dob) { setError(isHS ? "Cần đủ Họ tên, Lớp và Ngày sinh." : "Cần đủ Họ tên, CCCD/Mã định danh và Ngày sinh."); return; }
    setSubmitting(true); setError("");
    try {
      const r = await joinSchool(picked.id, role, isHS
        ? { name: name.trim(), dob, className: lop.replace(/\s+/g, "").toUpperCase() }
        : { name: name.trim(), dob, cccd: cccd.trim() });
      if (r.status === "matched" || r.status === "already") {
        setActiveSchoolId(picked.id);
        setResult("matched");
        setTimeout(() => onJoined && onJoined(), 900);
      } else {
        setResult("pending");
      }
    } catch (e) { setError(e.message); }
    finally { setSubmitting(false); }
  };

  return (
    <div style={{ maxWidth: 640, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px" }}>🏫 Tham gia trường học</h2>
      <p style={{ color: "#6b7280", fontSize: 14, marginTop: 0 }}>
        Chọn trường của bạn, chọn vai trò rồi nhập thông tin để hệ thống xác thực (học sinh: Họ tên + Lớp + Ngày sinh; giáo viên/nhân sự: Họ tên + CCCD + Ngày sinh).
      </p>
      {error && <p style={{ color: "#dc2626" }}>{error}</p>}

      {/* Kết quả */}
      {result === "matched" && (
        <div style={okBox}>✓ Xác thực thành công! Đang mở trường <b>{picked.name}</b>...</div>
      )}
      {result === "pending" && (
        <div style={pendBox}>
          ⏳ Không tìm thấy hồ sơ khớp trong <b>{picked.name}</b>. Yêu cầu của bạn đã được gửi tới <b>danh sách chờ xác thực</b> — nhà trường sẽ duyệt.
          <div style={{ marginTop: 10 }}><button onClick={reset} style={ghost}>Thử lại / chọn trường khác</button></div>
        </div>
      )}

      {!result && (
        loading ? <p>Đang tải danh sách trường...</p>
        : !picked ? (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 12 }}>
            {schools.length === 0 ? <p style={{ color: "#6b7280" }}>Chưa có trường nào trong hệ thống.</p> :
              schools.map((s) => (
                <button key={s.id} type="button" onClick={() => setPicked(s)} style={schoolCard}>
                  <span style={{ fontSize: 26 }}>🏫</span>
                  <span style={{ fontWeight: 600 }}>{s.name}</span>
                </button>
              ))}
          </div>
        ) : !role ? (
          <div style={panel}>
            <div style={{ marginBottom: 12 }}>Trường: <b>{picked.name}</b> — bạn là:</div>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button type="button" onClick={() => setRole("staff")} style={roleBtn}>👩‍🏫 Giáo viên / Nhân sự nhà trường</button>
              <button type="button" onClick={() => setRole("student")} style={roleBtn}>🎒 Học sinh</button>
            </div>
            <div style={{ marginTop: 14 }}><button onClick={reset} style={ghost}>← Chọn trường khác</button></div>
          </div>
        ) : (
          <div style={panel}>
            <div style={{ marginBottom: 12 }}>
              <b>{picked.name}</b> · {role === "student" ? "Học sinh" : "Giáo viên / Nhân sự"}
            </div>
            <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 10px" }}>Xác thực cần khớp <b>cả 3</b>: Họ tên, {role === "student" ? "Lớp" : "CCCD/Mã định danh"} và Ngày sinh có trong hồ sơ nhà trường.</p>
            <label style={fld}><span style={lbl}>Họ và tên {accountName ? "(từ tài khoản)" : ""}</span>
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder="VD: Nguyễn Văn A" style={inp} />
            </label>
            {role === "student" ? (
              <label style={fld}><span style={lbl}>Lớp</span>
                <input value={lop} onChange={(e) => setLop(e.target.value)} placeholder="VD: 12A4" autoCapitalize="characters" style={inp} />
              </label>
            ) : (
              <label style={fld}><span style={lbl}>Căn cước công dân</span>
                <input value={cccd} onChange={(e) => setCccd(e.target.value)} placeholder="12 số" style={inp} />
              </label>
            )}
            <label style={fld}><span style={lbl}>Ngày sinh</span>
              <input type="date" value={dob} onChange={(e) => setDob(e.target.value)} style={inp} />
            </label>
            <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
              <button onClick={() => setRole(null)} style={ghost}>← Quay lại</button>
              <button onClick={submit} disabled={submitting} style={primary}>{submitting ? "Đang xác thực..." : "Xác thực & tham gia"}</button>
            </div>
          </div>
        )
      )}
    </div>
  );
};

const schoolCard = { display: "flex", alignItems: "center", gap: 12, padding: 16, border: "1px solid #e5e7eb", borderRadius: 12, background: "#fff", cursor: "pointer", textAlign: "left" };
const panel = { border: "1px solid #e5e7eb", borderRadius: 12, padding: 18, background: "#fff", maxWidth: 460 };
const roleBtn = { flex: 1, minWidth: 200, padding: "16px 14px", border: "1px solid #0ea5a3", borderRadius: 10, background: "#f0fdfa", color: "#0f766e", fontWeight: 600, cursor: "pointer", fontSize: 14 };
const fld = { display: "block", marginBottom: 10 };
const lbl = { display: "block", fontSize: 13, fontWeight: 600, color: "#4b5563", marginBottom: 4 };
const inp = { width: "100%", padding: 9, border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" };
const primary = { padding: "9px 18px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
const ghost = { padding: "8px 14px", background: "#f3f4f6", color: "#374151", border: "1px solid #d1d5db", borderRadius: 8, cursor: "pointer" };
const okBox = { padding: 16, background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 10, color: "#065f46" };
const pendBox = { padding: 16, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, color: "#92400e" };

export default HappySchoolJoin;
